import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { BRAND } from "../../data/content";

const inputCls = "w-full min-h-[48px] rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white placeholder:text-platinum-dark outline-none focus:border-gold focus:ring-2 focus:ring-gold/30 transition";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-charcoal-void flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex flex-col items-center mb-8">
          <img src={BRAND.logo} alt="Taste of Platinum" className="w-20 h-20 rounded-full object-cover ring-1 ring-gold/40 mb-3" />
          <span className="font-serif text-3xl font-semibold text-white">Taste of <span className="gold-text">Platinum</span></span>
        </Link>
        <form onSubmit={submit} data-testid="admin-login-form" className="rounded-3xl border border-white/10 bg-white/[0.03] p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-xl bg-gold flex items-center justify-center"><Lock className="w-5 h-5 text-charcoal" /></div>
            <div>
              <h1 className="font-serif text-2xl text-white">Admin Sign In</h1>
              <p className="text-xs text-platinum-dark">Order management dashboard</p>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <label className="text-sm text-platinum">Email</label>
              <input data-testid="admin-email-input" type="email" className={`${inputCls} mt-1.5`} value={email} onChange={(e)=>setEmail(e.target.value)} required />
            </div>
            <div>
              <label className="text-sm text-platinum">Password</label>
              <input data-testid="admin-password-input" type="password" className={`${inputCls} mt-1.5`} value={password} onChange={(e)=>setPassword(e.target.value)} required />
            </div>
          </div>
          {error && <div data-testid="admin-login-error" className="mt-4 rounded-lg bg-crimson/20 border border-crimson/40 px-4 py-2.5 text-sm text-red-200">{error}</div>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 font-semibold text-charcoal hover:bg-gold-bright disabled:opacity-60">
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
